import { Download, RotateCcw } from 'lucide-react'
import { StepView } from './components/StepView'
import { useActivity } from './state/activity-context'

export default function App() {
  const { state, resetActivity } = useActivity()
  const studentName = state.fieldValues.student_name?.trim()

  async function reset() {
    const confirmed = window.confirm(
      'Deseja voltar ao início? O nome e a tela atual serão apagados deste navegador.',
    )
    if (confirmed) await resetActivity()
  }

  return (
    <div className="guide-app">
      <a className="skip-link" href="#main-content">
        Ir para o pedido atual
      </a>

      <header className="guide-header">
        <div className="guide-brand">
          <span className="guide-brand-mark" aria-hidden="true">
            ICP
          </span>
          <div>
            <strong>Recuperação prática</strong>
            <span>Roteiro de 3 horas no computador</span>
          </div>
        </div>

        <div className="guide-header-actions">
          {studentName && (
            <span className="student-greeting">
              Olá, <strong>{studentName.split(/\s+/)[0]}</strong>
            </span>
          )}
          <a className="quiet-action" href="/roteiro-recuperacao.txt" download>
            <Download size={17} aria-hidden="true" />
            Roteiro offline
          </a>
          <button
            type="button"
            className="quiet-action"
            onClick={() => void reset()}
          >
            <RotateCcw size={17} aria-hidden="true" />
            Recomeçar
          </button>
        </div>
      </header>

      <StepView />
    </div>
  )
}
